import { render, staticRenderFns } from "./ActiveFiltersList.vue?vue&type=template&id=26d808f2&"
import script from "./ActiveFiltersList.vue?vue&type=script&lang=ts&"
export * from "./ActiveFiltersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports